import React from "react";
import styles from "./Steps.module.css";

const Steps = ({ text, step }) => {
  return (
    <div className={styles.container}>
      <div className={styles.stepContainer}>
        <p className={styles.stepNumber}>{step}</p>
        <p className={styles.parrafo}>{text}</p>
      </div>

      <div className={styles.stepBorder}></div>
    </div>
  );
};

export default Steps;
